var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3a1 1 0 0 0-1 1v.441l12 7.385L24 4.44V4a1 1 0 0 0-1-1H1Zm23 3.79-11.476 7.062-.524.322-.524-.322L0 6.79V20a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V6.79Z",
  fill: "currentColor"
})));
export { SvgEmail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEgM0MwLjQ0NzcxNSAzIDAgMy40NDc3MiAwIDRWNC40NDEyTDEyIDExLjgyNThMMjQgNC40NDEyMVY0QzI0IDMuNDQ3NzIgMjMuNTUyMyAzIDIzIDNIMVpNMjQgNi43ODk1NkwxMi41MjQxIDEzLjg1MTdMMTIgMTQuMTc0MkwxMS40NzU5IDEzLjg1MTdMMCA2Ljc4OTU2VjIwQzAgMjAuNTUyMyAwLjQ0NzcxNiAyMSAxIDIxSDIzQzIzLjU1MjMgMjEgMjQgMjAuNTUyMyAyNCAyMFY2Ljc4OTU2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";